const MARKER = 'chatCsvExport';

/**
 * Hängt an jede Tabelle einer gerenderten Chat-Antwort einen Knopf „CSV" – Tabellen aus chatBIC
 * landen sonst per Abschreiben in Excel.
 *
 * <p>Wie `collapseLongLists` am DOM nach dem Rendern, weil ngx-markdown fertiges HTML einsetzt.
 * Idempotent: eine schon versehene Tabelle wird übersprungen.
 */
export function addTableCsvExport(root: HTMLElement | null | undefined, fileBaseName = 'chatBIC-Tabelle'): void {
  if (!root) return;
  root.querySelectorAll<HTMLTableElement>('table').forEach((table, index) => {
    if (table.dataset[MARKER]) return;
    table.dataset[MARKER] = 'true';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'chat-table-csv';
    button.textContent = 'Als CSV herunterladen';
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      downloadCsv(tableToCsv(table), `${fileBaseName}-${index + 1}.csv`);
    });
    table.insertAdjacentElement('afterend', button);
  });
}

/**
 * Tabelle als CSV im deutschen Excel-Format: Semikolon als Trenner, Felder in Anführungszeichen,
 * wenn sie Trenner, Anführungszeichen oder Umbrüche enthalten.
 */
export function tableToCsv(table: HTMLTableElement): string {
  return Array.from(table.rows)
    .map(row => Array.from(row.cells).map(cell => csvField((cell.textContent ?? '').trim())).join(';'))
    .join('\r\n');
}

function csvField(value: string): string {
  return /[;"\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

function downloadCsv(csv: string, fileName: string): void {
  // BOM, damit Excel die Datei als UTF-8 erkennt – sonst stehen Umlaute als Zeichensalat da.
  const blob = new Blob(['﻿' + csv], {type: 'text/csv;charset=utf-8'});
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
